// components/Footer.js
import React from 'react';

import './Footer.css';

import logo from '../assets/icons/logo.svg';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container">
        {/* Логотип */}
        <div className="footer__logo">
          <img src={logo} alt="Логотип" />
        </div>

        {/* Левый блок */}
        <div className="footer__left">
          <p>
            Email: <a href="mailto:noreply@mail.spygram.info">noreply@mail.spygram.info</a>
          </p>
          <p>
            Поддержка:{' '}
            <a href="https://t.me/loverbotsupport" target="_blank" rel="noopener noreferrer">
              Telegram
            </a>
          </p>
          <p>ИП "Павлов Владимир Витальевич"</p>
          <p>ИНН: 561601474841</p>
          <p>ОГРНИП: 324930100078071</p>
        </div>

        {/* Правый блок */}
        <div className="footer__right">
          <a href="https://spygram.info/oferta.html" target="_blank" rel="noopener noreferrer">
            Оферта
          </a>
          <a href="https://spygram.info/tariff.html" target="_blank" rel="noopener noreferrer">
            Условия предоставления услуг
          </a>
          <a href="https://spygram.info/pol-conf.html" target="_blank" rel="noopener noreferrer">
            Политика конфиденциальности
          </a>
          <a href="https://spygram.info/cancel-sub.html" target="_blank" rel="noopener noreferrer">
            Отменить подписку
          </a>
          <a href="https://spygram.info/refund.html" target="_blank" rel="noopener noreferrer">
            Вернуть средства
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
